import React from "react";
import { useNavigate } from "react-router-dom";
import {
  CommandDialog,
  CommandInput,
  CommandList,
  CommandEmpty,
  CommandGroup,
  CommandItem,
} from "./ui/command";
import { episodes } from "../mock";
import { articles } from "../articlesData";
import { Play, FileText } from "lucide-react";

const GlobalSearch = ({ open, onOpenChange }) => {
  const navigate = useNavigate();

  const go = (path) => {
    onOpenChange(false);
    navigate(path);
  };

  const nice = (c) => (c ? c.charAt(0) + c.slice(1).toLowerCase() : "");

  const blockText = (a) =>
    (a.blocks || [])
      .map((b) => (typeof b === "string" ? b : b.h || (b.ul ? b.ul.join(" ") : "")))
      .join(" ")
      .slice(0, 500);

  return (
    <CommandDialog open={open} onOpenChange={onOpenChange}>
      <CommandInput placeholder="Search episodes and articles…" />
      <CommandList>
        <CommandEmpty className="py-8 text-center font-display text-lg text-neutral-500">
          No results found.
        </CommandEmpty>

        <CommandGroup heading="Episodes">
          {episodes.map((ep) => (
            <CommandItem
              key={ep.id}
              value={`episode ${ep.title} ${ep.guest || ""} ${ep.guestName || ""} ${ep.category || ""}`}
              onSelect={() => go(`/episode/${ep.id}`)}
              className="cursor-pointer"
            >
              <Play size={16} className="text-neutral-500" />
              <div className="flex flex-col">
                <span className="font-display text-base text-neutral-900">{ep.title}</span>
                <span className="font-sans-ui text-xs text-neutral-500">
                  {ep.number} · {nice(ep.category)}
                </span>
              </div>
            </CommandItem>
          ))}
        </CommandGroup>

        <CommandGroup heading="Articles">
          {articles.map((a) => (
            <CommandItem
              key={a.slug}
              value={`article ${a.title} ${a.excerpt} ${nice(a.category)} ${(a.categories || []).join(" ")} ${blockText(a)}`}
              onSelect={() => go(`/article/${a.slug}`)}
              className="cursor-pointer"
            >
              <FileText size={16} className="text-neutral-500" />
              <div className="flex flex-col">
                <span className="font-display text-base text-neutral-900">{a.title}</span>
                <span className="font-sans-ui text-xs text-neutral-500">{nice(a.category)}</span>
              </div>
            </CommandItem>
          ))}
        </CommandGroup>
      </CommandList>
    </CommandDialog>
  );
};

export default GlobalSearch;
